<ng-container [ngSwitch]="displayType">
    <span *ngSwitchCase="'text'"
          class="delivery-text"
          (mouseover)="onHover($event)"
          (mouseleave)="onLeave()">#{{ deliveryNumber }}<span *ngIf="showSalesOrderInline && salesOrderNumber" class="sales-order-inline"> ({{ salesOrderNumber }})</span></span>

    <div *ngSwitchCase="'badge'"
         class="badge"
         [ngClass]="stopType === StopType.Pick ? '_success' : '_error'"
         (mouseover)="onHover($event)"
         (mouseleave)="onLeave()">
        <i [ngClass]="{
            'fas': true,
            'fa-download': stopType === StopType.Pick,
            'fa-upload': stopType === StopType.Drop
        }"></i>
        {{ deliveryNumber }}
        <span *ngIf="showSalesOrderInline && salesOrderNumber" class="sales-order-inline">({{ salesOrderNumber }})</span>
    </div>
</ng-container>

<div class="sales-order-tooltip"
     *ngIf="showTooltip && salesOrderNumber && !showSalesOrderInline"
     [style.left.px]="tooltipX"
     [style.top.px]="tooltipY">
    <span [i18n]="'common.sales-order-number'"></span>
    #{{ salesOrderNumber }}
</div>
